"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrityTag = exports.InventoryTag = exports.PatternTag = exports.BehaviourTag = exports.SourceTag = exports.ClickCoverage = exports.TAXONOMY_VERSION = void 0;
exports.TAXONOMY_VERSION = '2.0.0';
var ClickCoverage;
(function (ClickCoverage) {
    ClickCoverage["FULL"] = "full";
    ClickCoverage["BEHAVIOURAL_PENDING"] = "behavioural_pending";
    ClickCoverage["NETWORK_ONLY"] = "network_only";
    ClickCoverage["NONE"] = "none";
})(ClickCoverage = exports.ClickCoverage || (exports.ClickCoverage = {}));
var SourceTag;
(function (SourceTag) {
    SourceTag["RESIDENTIAL"] = "source.residential";
    SourceTag["CORPORATE"] = "source.corporate";
    SourceTag["DATACENTER"] = "source.datacenter";
    SourceTag["RESERVED_IP"] = "source.reserved_ip";
    SourceTag["ANONYMIZER_VPN"] = "source.anonymizer_vpn";
    SourceTag["TOR_EXIT"] = "source.tor_exit";
    SourceTag["OPEN_PROXY"] = "source.open_proxy";
    SourceTag["RESIDENTIAL_PROXY"] = "source.residential_proxy";
    SourceTag["ATTACK_SOURCE_LISTED"] = "source.attack_source_listed";
    SourceTag["DECLARED_CRAWLER"] = "source.declared_crawler";
    SourceTag["CLAIMED_CRAWLER"] = "source.claimed_crawler";
    SourceTag["CLAIMED_AI_AGENT"] = "source.claimed_ai_agent";
    SourceTag["SPOOFED_CRAWLER"] = "source.spoofed_crawler";
    SourceTag["UNDECLARED_AUTOMATION"] = "source.undeclared_automation";
    SourceTag["GEO_OUTSIDE_TARGET"] = "source.geo_outside_target";
    SourceTag["GEO_TIMEZONE_MISMATCH"] = "source.geo_timezone_mismatch";
    SourceTag["MOBILE_CARRIER"] = "source.mobile_carrier";
})(SourceTag = exports.SourceTag || (exports.SourceTag = {}));
var BehaviourTag;
(function (BehaviourTag) {
    BehaviourTag["HUMAN_CONSISTENT"] = "behaviour.human_consistent";
    BehaviourTag["CONVERTED"] = "behaviour.converted";
    BehaviourTag["LOW_ENGAGEMENT"] = "behaviour.low_engagement";
    BehaviourTag["NO_ENGAGEMENT"] = "behaviour.no_engagement";
    BehaviourTag["BOUNCE"] = "behaviour.bounce";
    BehaviourTag["FORM_ACTIVITY_WITHOUT_POINTER"] = "behaviour.form_activity_without_pointer";
    BehaviourTag["NO_POINTER_ACTIVITY"] = "behaviour.no_pointer_activity";
    BehaviourTag["SUPERHUMAN_TIMING"] = "behaviour.superhuman_timing";
    BehaviourTag["HEADLESS_CLIENT"] = "behaviour.headless_client";
    BehaviourTag["IMPOSSIBLE_EVENT_ORDER"] = "behaviour.impossible_event_order";
})(BehaviourTag = exports.BehaviourTag || (exports.BehaviourTag = {}));
var PatternTag;
(function (PatternTag) {
    PatternTag["REPEAT_DEVICE"] = "pattern.repeat_device";
    PatternTag["REPEAT_VISITOR"] = "pattern.repeat_visitor";
    PatternTag["REPEAT_IP"] = "pattern.repeat_ip";
    PatternTag["REPEAT_IP_RANGE"] = "pattern.repeat_ip_range";
    PatternTag["MULTI_CAMPAIGN_TARGETING"] = "pattern.multi_campaign_targeting";
    PatternTag["NON_CONVERTING_REPEAT"] = "pattern.non_converting_repeat";
    PatternTag["POST_CONVERSION_REPEAT"] = "pattern.post_conversion_repeat";
    PatternTag["NAVIGATIONAL_SUBSTITUTION"] = "pattern.navigational_substitution";
})(PatternTag = exports.PatternTag || (exports.PatternTag = {}));
var InventoryTag;
(function (InventoryTag) {
    InventoryTag["LOW_QUALITY_DOMAIN"] = "inventory.low_quality_domain";
    InventoryTag["APP_PLACEMENT"] = "inventory.app_placement";
    InventoryTag["DISPLAY_NETWORK"] = "inventory.display_network";
    InventoryTag["SEARCH_PARTNER_NETWORK"] = "inventory.search_partner_network";
    InventoryTag["BRAND_TERM"] = "inventory.brand_term";
    InventoryTag["META_AUDIENCE_NETWORK"] = "inventory.meta_audience_network";
})(InventoryTag = exports.InventoryTag || (exports.InventoryTag = {}));
var IntegrityTag;
(function (IntegrityTag) {
    IntegrityTag["CLICK_ID_REPLAY"] = "integrity.click_id_replay";
    IntegrityTag["UNVERIFIABLE"] = "integrity.unverifiable";
})(IntegrityTag = exports.IntegrityTag || (exports.IntegrityTag = {}));
